import BaseListPresenter from "../../base/BaseListPresenter";
import { getCurrentUserUseCase } from "../../usecases/user";
import {
  format,
  startOfDay,
  addHours,
  addMinutes,
  addDays,
  parseISO,
} from "date-fns";

class GrossSalesPresenter extends BaseListPresenter {
  init() {
    this.store = [];
    // this.limit = 20;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.filterDate = {};
    this.filterStore = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  async findObjects() {
    try {
      const user = await getCurrentUserUseCase().execute();
      const storeQuery = {
        include: ["all"],
        where: { email: user.email },
      };
      this.store = await this.findObjectUseCase.execute("users", storeQuery);
      const store = this.store[0].storeAnalytic.sort((a, b) => {
        const nameA = a.name.toUpperCase(); // ignore upper and lowercase
        const nameB = b.name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0; // names must be equal
      });
      this.view.setStore(store);
    } catch (error) {
      console.error("Error fetching user or store data:", error);
      return;
    }

    const skip = (this.current - 1) * this.limit;
    const storeCodes = this.store?.flatMap((storeItem) =>
      storeItem.storeAnalytic?.map((analytic) => analytic?.name)
    );

    const query = {
      // limit: 2000000,
      skip: skip,
      where: {
        store_code:
          this.filterStore === "AllStore"
            ? { $in: storeCodes }
            : this.filterStore,
        tran_date: this.filterDate && this.filterDate,
      },
      include: ["all"],
      sort: this.sort,
      keys: [
        "store_code",
        "status",
        "tran_date",
        "total",
        "total_tax",
        "createdAt",
        "discount_amount",
      ],
    };

    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const { count } = await this.countObjectUseCase.execute(
        this.view.getCollectionName(),
        { where: query.where }
      );

      this.count = count;
      console.log("this.count", this.count);
      this.view.setCount(this.count);

      let timeoutId = null;

      // Handle delayed "not found"
      if (this.count === 0) {
        timeoutId = setTimeout(() => {
          if (this.count === 0) {
            this.view.setNotFound(true);
            this.view.setObjects([]);
            this.view.setTotal(0);
          }
        }, 30000); // 15 seconds delay
      }

      // Batching logic
      let buffer = [];

      const flushBuffer = () => {
        if (buffer.length > 0) {
          this.view.setState((prevState) => ({
            objects: [...prevState.objects, ...buffer],
          }));
          this.objects = this.objects.concat(buffer);
          this.view.setTotal(this.objects.length);
          this.view.setObjects(this.objects);
          buffer = [];
        }
      };

      const onData = (objects) => {
        if (objects.length > 0 && timeoutId) {
          clearTimeout(timeoutId);
          timeoutId = null;
          this.view.setNotFound(false);
        }
        buffer.push(...objects);
      };

      const flushInterval = setInterval(flushBuffer, 2000);

      await this.findObjectUseCase.execute(
        this.view.getCollectionName(),
        query,
        {
          timeout: 100000,
          onData,
        }
      );

      clearInterval(flushInterval);
      flushBuffer();
      // const objects = await this.findObjectUseCase.execute(
      //   "transactions",
      //   query
      // );
      // this.objects = this.objects.concat(objects);
      // this.view.setTotal(this.objects.length);
      // this.view.setObjects(this.objects);
    } catch (error) {
      console.error("Error fetching objects:", error);
      this.view.showError(error);
    } finally {
      this.hideProgress();
      this.progress = false;
    }
  }

  // async findObjects() {
  //   // 1) Load user + store (kailangan para sa storeCodes)
  //   try {
  //     const user = await getCurrentUserUseCase().execute();
  //     const storeQuery = { include: ["all"], where: { email: user.email } };
  //     this.store = await this.findObjectUseCase.execute("users", storeQuery);

  //     const store = (this.store?.[0]?.storeAnalytic ?? []).sort((a, b) =>
  //       a.name.toUpperCase().localeCompare(b.name.toUpperCase())
  //     );
  //     this.view.setStore(store);
  //   } catch (error) {
  //     console.error("Error fetching user or store data:", error);
  //     return;
  //   }

  //   // 2) Build filters safely
  //   const storeCodes =
  //     this.store?.[0]?.storeAnalytic?.map((a) => a?.name).filter(Boolean) ?? [];

  //   // Safety: iwas full scan kapag walang date filter
  //   if (!this.filterDate || Object.keys(this.filterDate).length === 0) {
  //     console.log("No filterDate; aborting to avoid massive scan.");
  //     return;
  //   }

  //   const where = {
  //     store_code:
  //       this.filterStore === "AllStore"
  //         ? { $in: storeCodes }
  //         : this.filterStore,
  //     tran_date: this.filterDate, // ensure valid mongo-style range/object set upstream
  //   };

  //   const collection = this.view.getCollectionName();
  //   const pageSize = 1000 || 20;

  //   this.showProgress();
  //   try {
  //     this.findObjectUseCase.abort(); // cancel any in-flight

  //     // 3) Count muna gamit ang parehong WHERE
  //     const { count } = await this.countObjectUseCase.execute(collection, {
  //       where,
  //     });
  //     this.count = count ?? 0;
  //     this.view.setCount(this.count);

  //     // Reset UI state
  //     this.objects = [];
  //     this.view.setObjects([]);
  //     this.view.setTotal(0);
  //     this.view.setNotFound(false);

  //     // if (this.count === 0) {
  //     //   this.view.setNotFound(true);
  //     //   return;
  //     // }

  //     // 4) Batch pagination loop (20 per batch)
  //     let fetched = 0;
  //     let page = Math.max(0, (this.current || 1) - 1); // start page; set to 0 for full load from start

  //     // Shared buffer + periodic flush para smooth ang UI
  //     let buffer = [];
  //     const flushBuffer = () => {
  //       if (!buffer.length) return;
  //       this.objects = this.objects.concat(buffer);
  //       this.view.setObjects(this.objects);
  //       this.view.setTotal(this.objects.length);
  //       buffer = [];
  //     };
  //     const flushInterval = setInterval(flushBuffer, 1000);

  //     try {
  //       while (fetched < this.count) {
  //         const skip = page * pageSize;

  //         const query = {
  //           limit: pageSize, // <<— 20 per batch (or this.limit)
  //           skip,
  //           where,
  //           include: ["all"],
  //           sort: this.sort,
  //           keys: [
  //             "store_code",
  //             "status",
  //             "tran_date",
  //             "total",
  //             "total_tax",
  //             "createdAt",
  //             "discount_amount",
  //           ],
  //         };

  //         // Per-page accumulator via onData (streaming)
  //         let pageRowCount = 0;
  //         const onData = (rows) => {
  //           if (rows?.length) {
  //             buffer.push(...rows);
  //             pageRowCount += rows.length;
  //           }
  //         };

  //         // Execute one page (server should honor limit/skip)
  //         const result = await this.findObjectUseCase.execute(
  //           collection,
  //           query,
  //           { timeout: 100000, onData }
  //         );

  //         // Non-streaming fallback support
  //         if (result && Array.isArray(result.objects)) {
  //           if (result.objects.length) {
  //             buffer.push(...result.objects);
  //             pageRowCount += result.objects.length;
  //           }
  //         } else if (Array.isArray(result)) {
  //           if (result.length) {
  //             buffer.push(...result);
  //             pageRowCount += result.length;
  //           }
  //         }

  //         // Push streamed rows for this page
  //         flushBuffer();

  //         if (pageRowCount === 0) break; // no more data
  //         fetched += pageRowCount;
  //         page += 1;

  //         // yield to UI thread
  //         await Promise.resolve();
  //       }
  //     } finally {
  //       clearInterval(flushInterval);
  //       flushBuffer();
  //     }

  //     if (this.objects.length === 0) {
  //       this.view.setNotFound(true);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching objects:", error);
  //     this.view.showError(error);
  //   } finally {
  //     this.hideProgress();
  //     this.progress = false;
  //   }
  // }

  onChangeStore(where) {
    this.filterStore = where;
    this.getObjects();
  }

  onChangeDate(where) {
    if (where !== "AllMonths" && where) {
      const { $gte, $lte } = where;

      if ($gte && $lte) {
        const startDate = addHours(startOfDay(parseISO($gte)), 5);
        const endDate = addMinutes(
          addHours(addDays(startOfDay(parseISO($lte)), 0), 4),
          59
        );

        const formattedStartDate = format(startDate, "yyyy-MM-dd HH:mm:ss.SSS");
        const formattedEndDate = format(endDate, "yyyy-MM-dd HH:mm:ss.SSS");

        this.filterDate = {
          $gte: formattedStartDate,
          $lte: formattedEndDate,
        };
      }
    } else {
      delete this.filterDate;
    }
    this.getObjects();
  }
}

export default GrossSalesPresenter;
